import React from 'react'

export default function Tabla({tablas}) {
  
  const [tabla] = tablas;

      return (
        <div>
          {
            tabla.map((tabla, tind) => (
              <table key={tind} border={tabla.border} >
                {
                  
                  tabla.Header.map((head, hind) => (
                    <thead key={hind}>
                    {head.Title === '' ? '':
                      <tr>
                        <th colSpan={head.col.length > 0 ? head.col[0].length : 0 }>{head.Title}
                        </th>
                      </tr>
                    }
                      {

                        head.col.map((colh, icolh) => (
                          colh.length > 0 ?
                          <tr key={icolh}>
                            {
                              colh.map((rowh, irowh) => (
                                <td key={irowh}>{rowh}</td>
                            ))
                            }
                          </tr>
                          :''
                        ))


                      }
                    </thead>
                  ))
                }
                {
                  tabla.Body.map((body,ibody)=>(
                    <tbody key={ibody}>
                      {
                        body.col.map((colb,icolb)=>(
                          colb.length > 0 ?
                          <tr key={icolb}>
                            {
                             
                              colb.map((rowb,irowb)=>(
                                <td key={irowb} >
                                  <input readOnly value={rowb}/>
                                </td>
                              ))
                            }
                          </tr>
                          :
                              ''
                        ))
                      }
                    </tbody>
                  ))
                }
              </table>
            ))
          }
        </div>
      )
}
